import "../../../../node_modules/@lottiefiles/lottie-player/dist/lottie-player.esm.js";
import { create } from "../../../../node_modules/@lottiefiles/lottie-interactivity/dist/lottie-interactivity.es.js";

window.addEventListener("load", (event) => {
  document.querySelectorAll("lottie-player").forEach((player) => {
    const context = player.getAttribute("data-context");
    // Supports toggling the player when hovering over a different container.
    if (context && player.hover) {
      const container = player.closest(context);
      container.addEventListener("mouseenter", () => player.play());
      container.addEventListener("mouseleave", () => player.stop());
    }

    // Plays on scroll if the player is not set to autoplay
    if (!player.autoplay) {
      create({
        player,
        mode: "scroll",
        actions: [
          {
            visibility: [0.25, 0.6],
            type: "play" + (player.loop ? "" : "Once"),
          },
        ],
      });
    }
  });
});
